import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

// COMPONENTS

// CONFIGS
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';
import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';

// SERVICES
import { ClientApiService } from 'v2/modules/shared/services/api/client/client-api.service';
import { UiConfirmationDialogComponent } from 'v2/modules/ui/components/ui-confirmation-dialog/ui-confirmation-dialog.component';

@Component({
  selector: 'lum-client-pricing-structure-due-date-form',
  templateUrl: './client-pricing-structure-due-date-form.component.html',
  styleUrls: ['./client-pricing-structure-due-date-form.component.scss'],
})
export class ClientPricingStructureDueDateFormComponent
  implements OnInit, OnDestroy
{
  @Input()
  businessAccount :any;

  form :FormGroup;
  loading :boolean = false;

  private onDestroy$ = new Subject<void>();

  constructor(
    private cd :ChangeDetectorRef,
    private clientApiService :ClientApiService,
    private fb :FormBuilder,
    private dialog :MatDialog,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  initForm() :void {
    this.form = this.fb.group({
      dueDateDays: [this.businessAccount?.due_date_days || null],
    });
  }

  onClear() :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Clear Default Due Date',
          message:
            "This will clear the default due date for this client's invoices. Are you sure you want to proceed?",
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((confirm :boolean) => {
        if (confirm) {
          this.form.reset();
          this.onSubmit();
        }
      });
  }

  onSubmit() :void {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    this.clientApiService
      .setDefaultDueDate(this.businessAccount?.id, this.form.value)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.loading = false;
          this.cd.detectChanges();
        }),
      )
      .subscribe({
        next: (resp :any) => {
          this.snackBar.open('Successfully updated.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: (error :any) => {
          console.error('Error updating profile', error);
          this.snackBar.open('Failed to update default due date.', 'Error', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }
}
